import React, { type FC } from 'react';
import { Title } from '@telegram-apps/telegram-ui';

import type { Course } from '@/api/entitties';
import { renderContent } from '@/helpers/contentRenderer';
import styles from './CourseCard.module.css';

interface CourseCardProps {
  course: Course;
  entitled: boolean;
  onClick: () => void;
}

// Play icon component - memoized to prevent recreation on each render
const PlayIcon: FC = React.memo(() => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: '#ffffff' }}
  >
    <defs>
      <mask id="playMask">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path d="M8.5 5.5 Q8 5 8 5.5 v13 Q8 19 8.5 18.5 L18.5 12.5 Q19 12 18.5 11.5 Z" fill="black" />
      </mask>
    </defs>
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="currentColor"
      mask="url(#playMask)"
    />
  </svg>
));

export const CourseCard: FC<CourseCardProps> = ({
  course,
  entitled,
  onClick,
}) => {
  return (
    <div
      data-course-id={course.id}
      className={`${styles['course-card']} ${styles['card-container']}`}
      onClick={onClick}
    >
      <div className={styles['title-row']}>
        <Title level={'2'} weight={'2'} className={styles.title}>{course.title}</Title>
        {entitled && <PlayIcon />}
      </div>

      {course.course_card && course.course_card.content && Array.isArray(course.course_card.content)
        ? course.course_card.content
            .filter(Boolean)
            .map((item, i) => (
              <div key={i}>
                {renderContent(item)}
              </div>
            ))
        : null
      }
    </div>
  );
};